{
    "name":  "my-app",
    "version":  "2.24.7852-Prod20261026.1",
    "private":  true,
    "scripts":  {
                    "dev":  "vite",
                    "build":  "tsc --noEmit \u0026\u0026 vite build",
                    "preview":  "vite preview",
                    "start":  "vite preview",
                    "lint":  "oxlint src",
                    "typecheck":  "tsc --noEmit",
                    "test":  "jest",
                    "test:watch":  "jest --watch",
                    "seed:trades":  "node scripts/seedTrades.mjs"
                },
    "//":  "AG Grid pinned at 31.x. On upgrade to \u003e= 35: v35 adds a built-in \u0027No matching rows\u0027 overlay, so the syncNoRowsOverlay onModelUpdated wire-ups in CreationTable/ActionSummaryTable (LQC-2482) can go, but AGGridNoRowsOverlay\u0027s clear-filters button is not built-in, so re-evaluate rather than delete. The overlay*Template props are also legacy from v32 onward.",
    "dependencies":  {
                         "@auth0/auth0-react":  "^2.2.1",
                         "@dnd-kit/core":  "^6.1.0",
                         "@emotion/react":  "^11.14.0",
                         "@emotion/styled":  "^11.14.1",
                         "@headlessui/react":  "^2.2.0",
                         "@microsoft/signalr":  "^8.0.7",
                         "@microsoft/signalr-protocol-msgpack":  "^8.0.7",
                         "@mui/material":  "^6.5.0",
                         "@types/node":  "^20.19.43",
                         "ag-charts-enterprise":  "11.3.0",
                         "ag-charts-react":  "11.3.0",
                         "ag-grid-community":  "^31.3.4",
                         "ag-grid-enterprise":  "^31.2.1",
                         "ag-grid-react":  "^31.2.1",
                         "async-mutex":  "^0.5.0",
                         "autoprefixer":  "^10.4.21",
                         "axios":  "^1.7.2",
                         "big.js":  "^7.0.1",
                         "class-variance-authority":  "^0.7.0",
                         "clsx":  "^2.0.0",
                         "date-fns":  "^4.1.0",
                         "dompurify":  "^3.4.2",
                         "next-themes":  "^0.4.6",
                         "quill":  "^2.0.3",
                         "react":  "^18.3.1",
                         "react-custom-scrollbars-2":  "^4.5.0",
                         "react-datepicker":  "^8.4.0",
                         "react-dom":  "^18.3.1",
                         "react-grid-layout":  "^1.4.4",
                         "react-new-window":  "^1.0.1",
                         "react-select":  "^5.8.0",
                         "react-toastify":  "^10.0.4",
                         "react-tooltip":  "^5.28.0",
                         "tailwind-merge":  "^1.14.0",
                         "tailwindcss":  "3.3.3",
                         "zustand":  "^4.5.0"
                     },
    "devDependencies":  {
                            "@swc/core":  "^1.15.43",
                            "@swc/jest":  "^0.2.39",
                            "@testing-library/dom":  "^10.2.0",
                            "@testing-library/jest-dom":  "^6.4.6",
                            "@testing-library/react":  "^14.3.1",
                            "@types/big.js":  "^6.2.2",
                            "@types/jest":  "^30.0.0",
                            "@types/react":  "^18.3.3",
                            "@types/react-datepicker":  "^6.2.0",
                            "@types/react-dom":  "^18.3.0",
                            "@types/react-grid-layout":  "^1.3.5",
                            "@vitejs/plugin-react-swc":  "^4.3.1",
                            "identity-obj-proxy":  "^3.0.0",
                            "jest":  "^30.4.2",
                            "jest-environment-jsdom":  "^30.4.1",
                            "oxlint":  "^1.76.0",
                            "prettier":  "^3.2.4",
                            "prettier-plugin-tailwindcss":  "^0.5.11",
                            "tailwindcss":  "3.3.3",
                            "typescript":  "^7.0.2",
                            "vite":  "^8.1.4"
                        },
    "overrides":  {
                      "glob":  "^11.0.3",
                      "babel-plugin-istanbul":  "^8.0.2"
                  }
}
